import { takeLatest, put } from 'redux-saga/effects';
import pqrsSlice from 'store/modules/pqrs';
import uiSlice from 'store/modules/ui';
import pqrs from 'api/graphql/pqrs';
import { createSnack, getUserFriendlyError } from 'common/utils/general';
import i18n from 'i18n';

function* listMine() {
  try {
    const response = yield pqrs.myPqrs();
    yield put(pqrsSlice.actions.listMineSuccess(response.data.myPqrs));
  } catch (ex) {
    yield put(pqrsSlice.actions.listMineError(getUserFriendlyError(ex)));
  }
}

function* listAdmin(action) {
  try {
    const response = yield pqrs.adminList(action.payload);
    const { data, paginatorInfo } = response.data.pqrsTickets;
    yield put(pqrsSlice.actions.listAdminSuccess({ data, paginatorInfo }));
  } catch (ex) {
    yield put(pqrsSlice.actions.listAdminError(getUserFriendlyError(ex)));
  }
}

function* find(action) {
  try {
    const id = action.payload.id || action.payload;
    const response = yield pqrs.find(id);
    yield put(pqrsSlice.actions.findSuccess(response.data.pqrs));
  } catch (ex) {
    yield put(pqrsSlice.actions.findError(getUserFriendlyError(ex)));
  }
}

function* create(action) {
  try {
    const response = yield pqrs.create(action.payload);
    yield put(pqrsSlice.actions.createSuccess(response.data.createPqrs));
    yield put(uiSlice.actions.enqueueSnackbar(createSnack({
      key: 'pqrs-create-success',
      variant: 'success',
      message: i18n.t('pqrs.created', { ns: 'notifications', defaultValue: 'Tu solicitud fue enviada. Te responderemos pronto.' })
    })));
    yield put(pqrsSlice.actions.listMine());
  } catch (ex) {
    yield put(pqrsSlice.actions.createError(getUserFriendlyError(ex)));
  }
}

function* reply(action) {
  try {
    const response = yield pqrs.reply(action.payload);
    yield put(pqrsSlice.actions.replySuccess(response.data.replyPqrs));
    yield put(uiSlice.actions.enqueueSnackbar(createSnack({
      key: 'pqrs-reply-success',
      variant: 'success',
      message: i18n.t('pqrs.replied', { ns: 'notifications', defaultValue: 'Mensaje enviado.' })
    })));
  } catch (ex) {
    yield put(pqrsSlice.actions.replyError(getUserFriendlyError(ex)));
  }
}

function* updateStatus(action) {
  try {
    const response = yield pqrs.updateStatus(action.payload);
    yield put(pqrsSlice.actions.updateStatusSuccess(response.data.updatePqrsStatus));
    yield put(uiSlice.actions.enqueueSnackbar(createSnack({
      key: 'pqrs-status-success',
      variant: 'success',
      message: i18n.t('pqrs.statusUpdated', { ns: 'notifications', defaultValue: 'Estado actualizado.' })
    })));
  } catch (ex) {
    yield put(pqrsSlice.actions.updateStatusError(getUserFriendlyError(ex)));
  }
}

export default function* watchPqrs() {
  yield takeLatest(pqrsSlice.actions.listMine, listMine);
  yield takeLatest(pqrsSlice.actions.listAdmin, listAdmin);
  yield takeLatest(pqrsSlice.actions.find, find);
  yield takeLatest(pqrsSlice.actions.create, create);
  yield takeLatest(pqrsSlice.actions.reply, reply);
  yield takeLatest(pqrsSlice.actions.updateStatus, updateStatus);
}
